/**
 * @file Task detail adapter contract.
 */

import {
    getTaskDetailFields,
    setupTaskDetailPeopleControls,
    setupTaskDetailRecurrenceControls,
    setupTaskDetailScalarControls,
    setupTaskDetailTypeControls,
} from './taskDetails.js';
import {
    handleTaskAssignedUsersTeamSelection,
} from './taskAssignmentControls.js';

/**
 * Detail adapter for Task items.
 */
export const taskDetailAdapter = {
    itemType: 'task',
    viewName: 'tasks',
    statusConfigKey: 'taskStatus',
    typeConfigKey: 'taskTypes',
    liveSaveFields: [
        'assigned_users',
        'priority',
        'status',
        'types',
    ],
    sections: [
        'checklist',
        'notes',
        'attachments',
    ],
    renderFields: getTaskDetailFields,
    mountControls(detailsViewContainer, item) {
        setupTaskDetailScalarControls(detailsViewContainer, item);
        setupTaskDetailTypeControls(detailsViewContainer, item);
        setupTaskDetailPeopleControls(detailsViewContainer, item);
    },
    attachPostFormListeners(detailsViewContainer, item, context) {
        setupTaskDetailRecurrenceControls(
            detailsViewContainer,
            item,
            context.enableSaveButtons,
            context.uiDraft,
        );
    },
    handleControlValueChange({ event, item, itemType, value, saveRegisteredDetailValue }) {
        return handleTaskAssignedUsersTeamSelection({
            event,
            item,
            itemType,
            value,
            saveRegisteredDetailValue,
        });
    },
    getBackNavigation({ item, state, findItem }) {
        const taskParent = item?.parentId ? findItem(item.parentId) : null;
        if (state.originatingView === 'tasks') {
            return { type: 'view', view: 'tasks' };
        }
        if (taskParent) {
            return { type: 'detail', id: taskParent.id };
        }
        return { type: 'view', view: state.originatingView || 'tasks' };
    },
    getDeleteNavigation({ state }) {
        return { type: 'view', view: state.originatingView || 'tasks' };
    },
};
